export const SIGNUP_COMPLETED = 'SIGNUP_COMPLETED';
export const SIGNUP_FINALIZED = 'SIGNUP_FINALIZED';
export const SIGNUP_REJECTED = 'SIGNUP_REJECTED';

export const SIGNUP_STATEMENT_UPLOADED = 'SIGNUP_STATEMENT_UPLOADED';
export const SIGNUP_STATEMENT_VALID = 'SIGNUP_STATEMENT_VALID';
export const SIGNUP_TEST_SAVED = 'SIGNUP_TEST_SAVED';
export const SIGNUP_TEST_VALID = 'SIGNUP_TEST_VALID';
export const SIGNUP_DATA1_SAVED = 'SIGNUP_DATA1_SAVED';
export const SIGNUP_DATA1_VALID = 'SIGNUP_DATA1_VALID';
export const SIGNUP_DATA2_SAVED = 'SIGNUP_DATA2_SAVED';
export const SIGNUP_DATA2_VALID = 'SIGNUP_DATA2_VALID';
export const SIGNUP_DATA3_SAVED = 'SIGNUP_DATA3_SAVED';
export const SIGNUP_DATA3_VALID = 'SIGNUP_DATA3_VALID';

export const SIGNUP_AGREEMENT1_ACCEPTED = 'SIGNUP_AGREEMENT1_ACCEPTED';
export const SIGNUP_AGREEMENT2_ACCEPTED = 'SIGNUP_AGREEMENT2_ACCEPTED';
export const SIGNUP_AGREEMENT3_ACCEPTED = 'SIGNUP_AGREEMENT3_ACCEPTED';
export const SIGNUP_AGREEMENTS_ACCEPTED = 'SIGNUP_AGREEMENTS_ACCEPTED';





/** WEBPACK FOOTER **
 ** ./common/progressTypes.js
 **/